<template>
    <v-container class="reader">
        <v-row>
            <v-col>
                <span class="text-h5">All Events</span>
            </v-col>
            <v-col>
                <div class="d-flex justify-center justify-md-end mb-2">
                    <v-btn :to="{ name: 'newEvent' }" title="Create a new event" color="success"
                        ><v-icon class="mr-2">mdi-plus</v-icon>New</v-btn
                    >
                </div>
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="events"
            :items-per-page="15"
            dense
            class="elevation-1"
            :footer-props="{
                showFirstLastPage: true,
                itemsPerPageOptions: [-1, 10, 15, 20, 25],
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus',
            }"
        >
            <template v-slot:[`item.name`]="{ item }">
                <router-link :to="{ name: 'editEvent', params: { id: item.id } }" :title="item.name">
                    {{ item.name }}
                </router-link>
            </template>
            <template v-slot:[`item.startDate`]="{ item }">
                {{ item.startDate | luxonSortableDate }}
            </template>
            <template v-slot:[`item.endDate`]="{ item }">
                {{ item.endDate | luxonSortableDate }}
            </template>
        </v-data-table>
    </v-container>
</template>
<script>
import api from '@/api'
export default {
    data() {
        return {
            isLoading: false,
            events: [],
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                    width: '50%',
                },
                { text: 'Start Date', value: 'startDate', filterable: false, width: '25%' },
                { text: 'End Date', value: 'endDate', filterable: false, width: '25%' },
            ],
        }
    },
    mounted() {
        this.getEvents()
    },
    methods: {
        getEvents() {
            this.isLoading = true
            api.get('event/getAll')
                .then(res => (this.events = res))
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
</script>
